import { action } from 'typesafe-actions';
import { ResponseError } from '../../../services/api';
import { HomeProductsTypes } from './types';

export const loadRequest = () => action(HomeProductsTypes.LOAD_REQUEST);
export const loadSuccess = (data: any[], config: any[]) =>
  action(HomeProductsTypes.LOAD_SUCCESS, { data, config });
export const loadFailure = (error: ResponseError) =>
  action(HomeProductsTypes.LOAD_FAILURE, { error });
